import { useState, useMemo } from "react";
import { Button } from "react-bootstrap";
import DownloadModal from "../Modal/DownloadModal";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../../../slices/common/reducer";

const useOrderReports = () => {
  // const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const modalShow = useSelector((state) => state.common.modalShow);

  const handleDownloadClick = () => {
    dispatch(openModal(true));
  };

  const handleClose = () => {
    dispatch(openModal(false));
  };

  const handleConfirmDownload = (format) => {
    console.log("Download format selected:", format);

    handleClose();
  };

  const orderReportsColumns = [
    {
      header: "Name",
      accessorKey: "name",
      size: 200,
    },
    {
      header: "Action",
      accessorKey: "action",
      cell: ({ row }) => (
        <Button
          variant="primary"
          onClick={() => {
            dispatch(openModal({ show: true, type: row.original.type }));

          }}
        >
          {row.original.action}
        </Button>
      ),


      meta: { align: "center" },
      size: 150,
    },
  ];


  return { orderReportsColumns };
};

export default useOrderReports;
